import { LottiesContext } from '@/pages/(gapsdk)/_provider/lotties-provider';
import { useContext } from 'react';
import CustomLottie from './custom-lottie';

export default function CustomLoading(props: {
  title?: string;
  className?: string;
}) {
  const { loading } = useContext(LottiesContext);
  return (
    <CustomLottie
      animationData={loading}
      className={`${props.className} size-[80px]`}
      loop={true}
    />
  );
}
